/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTipDeclarationSettingsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetTipDeclarationSettingsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getTipDeclarationSettings = (request: GetTipDeclarationSettingsRequest, options?: CashRequestOptions) => post<GetTipDeclarationSettingsRequest, GetTipDeclarationSettingsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetTipDeclarationSettings", request, {...options, rejectOnError: true })